import React, { useContext, useState, useLayoutEffect } from "react";
import "ui-theme/dist/semantic.min.css";
import "./App.css";
import { Container } from "semantic-ui-react";
import { CSSTransition } from "react-transition-group";
import { AppStoreContext } from "./stores/AppStore";
import { routes, ROUTES } from "./stores/routes";
import { observer } from "mobx-react-lite";
import AppStepper from "./components/AppStepper";
import ModalWhatsNext from "./components/ModalWhatsNext";
import ModalReminder from "./components/ModalReminder";
import ModalError from "./components/ModalError";
import { GLOBAL_MODALS } from "./stores/modals";
import ModalExpired from "./components/ModalExpired";
import {trackAction} from "./tracking";
import OnboardingActions from "./tracking/actions";
import { useTranslation } from "react-i18next";
import { RateStoreContext } from "./stores/RateStore";
import ModalInvalidReferralToken from "./components/ModalInvalidReferralToken";

export default observer(function App() {
  const appStore = useContext(AppStoreContext);
  const rateStore = useContext(RateStoreContext);
  const [intro, setIntro] = useState(false);
  const [t] = useTranslation()
  // TODO: move logic for tranlation based for other languages as well if needed
  const policyUrl = appStore.locale === 'ja' ? 'https://glginsights.com/ja/privacy-policy/' : 'https://glginsights.com/privacy/';

  useLayoutEffect(() => setIntro(true), []);

  const renderError = () => {
    if (appStore.globalModal !== GLOBAL_MODALS.FATAL_ERROR) {
      return null;
    }
    trackAction(OnboardingActions.global.FatalError);
    return appStore.expired ? <ModalExpired /> : <ModalError />
  }
  
  return (
    <CSSTransition in={intro} timeout={500} classNames="app-fade-in">
      <div className="app-fade-in">
        <Container className="app-container">
          <AppStepper />

          {routes.map(
            r =>
              appStore.currentRoute === r && (
                <r.component className="app-section" key={r.name} />
              )
          )}
        </Container>

        {appStore.globalModal === GLOBAL_MODALS.WHATS_NEXT && <ModalWhatsNext />}
        {appStore.globalModal === GLOBAL_MODALS.SET_REMINDER && <ModalReminder />}
        {appStore.globalModal === GLOBAL_MODALS.INVALID_REFERRAL_TOKEN && <ModalInvalidReferralToken />}
        {renderError()}

        {
          appStore.currentRoute !== ROUTES.REGISTER &&
          rateStore.isLoading === false &&
          <div style={{padding: "1rem 2rem"}}>
            <a href={policyUrl} target="_blank" rel="noopener noreferrer">{t('privacy_policy')}</a>
          </div>
        }
      </div>
    </CSSTransition>
  );
});
